export const comingSoon = {
	bars: {
		title: "Add Bars",
		message: "This feature will be implemented soon",
	},
	mountableProduct: {
		title: "Mountable product",
		message: "This feature will be implemented soon",
	},
	technicalSheet: {
		title: "Add technical sheet",
		message: "This feature will be implemented soon",
	},
};
